// @flow
import {Map, List} from 'immutable';
import type {AuthoringGuideModelV1} from 'resources/GeneratedModels/AuthoringGuide/AuthoringGuideModel.v1';

// See note below, this is hysterically temporary
const __withUserRelationshipGetters = function (data): Object {
  return {
    getCanEditGuideLevels(): boolean {
      return data.get('can_edit_guide_levels', null);
    },
    getCanEditQuestions(): boolean {
      return data.get('can_edit_questions', null);
    },
    getCanEditSupplements(): boolean {
      return data.get('can_edit_supplements', null);
    }
  };
};

export const authoringSubjectExtensions = {
  getPracticeGuide(): AuthoringGuideModelV1 {
    return this.getAuthoringGuides().find((guide) => guide.getGuideType() === 'practice');
  },

  /**
   * TODO: 7/18 - determine if this is still a thing
   *
   * TODO: This is a workaround for a busted auto-generated getter.
   *
   * Parsedoc needs to be fixed so that relationship getters are using the
   * name field and not the type. We also need to ensure that the name field
   * is singular and not plural, which we need the model registry to do.
   *
   * We can't do THAT though, until things are babelfied and whatever.
   *
   * instead, we do this workaround by redefining a relationship getter with
   * exactly what we want
   */

  getAuthorRelationships(id: string): List<*> {
    const data = this.getIn(['relationshipMeta', 'author'], new Map());
    if (!id) {
      return data.map((rel) => this.__withUserRelationshipGetters(rel));
    } else {
      return __withUserRelationshipGetters(data.get(id, new Map()));
    }
  }
};
